import { createAction, handleActions } from 'redux-actions';
import produce from 'immer';

// 액션 타입을 정의해줍니다.
const INIT_FETCH_ERR_FLAG = 'errStateAction/initFetchErrState';
const SET_FETCH_ERR_FLAG = 'errStateAction/setFetchErrState';
const INIT_TOO_MANY_REQ_ERR_FLAG = 'errStateAction/initTooManyReqErrState';
const SET_TOO_MANY_REQ_ERR_FLAG = 'errStateAction/setTooManyReqErrState';

// 액션 생성 함수를 만듭니다.
export const initFetchErrState = createAction(INIT_FETCH_ERR_FLAG);
export const setFetchErrState = createAction(SET_FETCH_ERR_FLAG);
export const initTooManyReqErr = createAction(INIT_TOO_MANY_REQ_ERR_FLAG);
export const setTooManyReqErr = createAction(SET_TOO_MANY_REQ_ERR_FLAG);

// 모듈의 초기 상태를 정의합니다.
const initialState = {
  fetchErrTriggerd:false,
  tooManyReqTriggered: false
};

// immer 를 사용하여 값을 수정하는 리듀서입니다.
export default handleActions({
  [INIT_FETCH_ERR_FLAG]: (state, action) => {
    return produce(state, draft => {
      draft.fetchErrTriggerd = false;
    });
  },
  [SET_FETCH_ERR_FLAG]: (state, action) => {
    return produce(state, draft => {
      draft.fetchErrTriggerd = action.payload.fetchErrTriggerd;
    });
  },
  [INIT_TOO_MANY_REQ_ERR_FLAG]: (state, action) => {
    return produce(state, draft => {
      draft.tooManyReqTriggered = false;
    });
  },
  [SET_TOO_MANY_REQ_ERR_FLAG]: (state, action) => {
    return produce(state, draft => { 
      draft.tooManyReqTriggered = action.payload.tooManyReqTriggered;
    });
  },
}, initialState);